import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/77e67204/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "overflow-menu"
    }}>{`Overflow menu`}</h2>
    <ComponentCode name="Overflow menu" component="overflow-menu" variation="overflow-menu" hasReactVersion hasVueVersion="overflowmenu--default" hasAngularVersion="?path=/story/overflow-menu--basic" codepen="PgNGop" mdxType="ComponentCode"></ComponentCode>
    <h2 {...{
      "id": "overflow-menu-up"
    }}>{`Overflow menu up`}</h2>
    <ComponentCode name="Overflow menu up" component="overflow-menu" variation="overflow-menu--up" hasReactVersion codepen="ZZWpbV" mdxType="ComponentCode"></ComponentCode>
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <ComponentDocs component="overflow-menu" mdxType="ComponentDocs"></ComponentDocs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      